module.exports = __webpack_public_path__ + "img/unknow.5f99c8ef.png";